module.exports = __webpack_public_path__ + "23199dae066931aeac7e9f944d644770.svg";